import {FETCH_ANALYSIS_LEVEL_GUIDE, FETCH_ANALYSIS_LEVEL_GUIDE_SUCCESS, FETCH_ANALYSIS_LEVEL_GUIDE_ERROR, RESET_ANALYSIS_LEVEL_GUIDE} from "constants/ActionTypes";

export const fetchAnalysisLevelGuide = () => {
  return {
    type: FETCH_ANALYSIS_LEVEL_GUIDE,
  }
};

export const fetchAnalysisLevelGuideSuccess = (payload) => {
  return {
    type: FETCH_ANALYSIS_LEVEL_GUIDE_SUCCESS,
    payload,
  }
};

export const fetchAnalysisLevelGuideError = (error) => {
  return {
    type: FETCH_ANALYSIS_LEVEL_GUIDE_ERROR,
    payload: error
  }
};

export const resetAnalysisLevelGuide = () => {
  return {
    type: RESET_ANALYSIS_LEVEL_GUIDE,
  }
};
